module.exports = __webpack_public_path__ + "CreativeDirection2.png?7ad389fac01f7556291693f6972c4a6f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection2.png
// module id = 31
// module chunks = 0